"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
exports.actionCreators = {
    requestFunction: function (appName, email, username, password, method, version) { return function (dispatch, getState) {
        var appState = getState();
        var body = {
            'app_name': appName,
            'email': email,
            'username': username,
            'password': password
        };
        if (appState && appState.applicationManage && method == "POST") {
            console.log("call api register apps");
            fetch("/v1/apps/register", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                console.log("register apps success. - " + version);
                dispatch({ type: 'RECEIVE_APPLICATIONMANAGE', model: data, version: version });
            })
                .then(function (error) {
            });
            dispatch({ type: 'REQUEST_APPLICATIONMANAGE' });
        }
    }; }
};
var unloadedState = { isLoading: false, response: undefined, version: 0 };
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_APPLICATIONMANAGE':
            return {
                isLoading: false,
                version: 0
            };
        case 'RECEIVE_APPLICATIONMANAGE':
            return {
                isLoading: true,
                response: action.model,
                version: action.version + 1
            };
        default: return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=ApplicationManage.js.map